import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/* Router guards */
import { LoginGuard } from '@core/guards/login.guard';
import { LoginWithRecoveryCodeComponent } from './login-with-recovery-code/login-with-recovery-code.component';

/* Components */
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
	{
		path: 'login-with-recovery-code',
		component: LoginWithRecoveryCodeComponent,
		canActivate: [LoginGuard],
		data: { title: 'Login With Recovery Code' },
	},
	{
		path: 'login',
		component: LoginComponent,
		canActivate: [LoginGuard],
		data: { title: 'Login' },
	},
	{
		path: 'reset-password',
		component: ResetPasswordComponent,
		canActivate: [LoginGuard],
		data: { title: 'Reset Password' },
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AuthRoutingModule {}
